var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2076_3628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 1.75C7.41087 1.75 6.96575 1.93437 6.63756 2.26256C6.30937 2.59075 6.125 3.03587 6.125 3.5V5.25H7.875V3.5H17.5V13.125H15.75V14.875H17.5C17.9641 14.875 18.4092 14.6906 18.7374 14.3624C19.0656 14.0342 19.25 13.5891 19.25 13.125V3.5C19.25 3.03587 19.0656 2.59075 18.7374 2.26256C18.4092 1.93437 17.9641 1.75 17.5 1.75H7.875ZM3.5 6.125C3.03587 6.125 2.59075 6.30937 2.26256 6.63756C1.93437 6.96575 1.75 7.41087 1.75 7.875V17.5C1.75 17.9641 1.93437 18.4092 2.26256 18.7374C2.59075 19.0656 3.03587 19.25 3.5 19.25H13.125C13.5891 19.25 14.0342 19.0656 14.3624 18.7374C14.6906 18.4092 14.875 17.9641 14.875 17.5V7.875C14.875 7.41087 14.6906 6.96575 14.3624 6.63756C14.0342 6.30937 13.5891 6.125 13.125 6.125H3.5Z",
    fill: "#EFE7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2076_3628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f84b291003be878d388093a45ded5c9b.svg";
export { ForwardRef as ReactComponent };